import React, { useEffect } from "react";
import { Button } from "components";
import confetti from "canvas-confetti";


const Step7 = ({ skipSetup }) => {

	useEffect(() => {

		const count = 200;
		const defaults = {
			origin: { y: 0.7 }
		};

		const fire = (particleRatio, opts) => {
			confetti(Object.assign({}, defaults, opts, {
				particleCount: Math.floor(count * particleRatio)
			}));
		}

		fire(0.25, {
			spread: 26,
			startVelocity: 55,
		});
		fire(0.2, {
			spread: 60,
		});
		fire(0.35, {
			spread: 100,
			decay: 0.91,
			scalar: 0.8
		});
		fire(0.1, {
			spread: 120,
			startVelocity: 25,
			decay: 0.92,
			scalar: 1.2
		});
		fire(0.1, {
			spread: 120,
			startVelocity: 45,
		});

	}, []);

	return (
		<div className="d-flex align-items-center justify-content-center flex-column py-5 my-5 px-3">
			<h4 style={{ fontSize: 30, lineHeight: "30px" }} className="mb-0">Congratulations</h4>

			<div style={{ textAlign: "center", color: "var(--black5)" }} className="text-center my-4">
				You have successfully configured the basics of your shop, for a deeper customization proceed to the settings page in a moment.
			</div>

			<div className="setup-screen-step-buttons align-items-center justify-content-center">
				<Button type="submit" size="large" onClick={skipSetup}>
					Go to dashboard
				</Button>
			</div>

		</div>
	)
}

export default Step7;
